module.exports = __webpack_public_path__ + "8c70b11d252764509b6350be5abc5fcc.svg";